import { ActivatedRoute, Route, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { catchError, finalize, of } from 'rxjs';
import { resolve } from 'path/win32';

import { EstateAgentDocumentDto, EstateAgentDto, ReportDocumentDto, UrbanPlannerDocumentDto, UrbanPlannerDto, UserDto } from '../../../../../app/services/property-matrixV2/models';
import { LookupService, PlanningReportService, ReportGeneratorService, UserManagementService } from '../../../../../app/services/property-matrixV2/services';
import { ListingDocumentAddEditComponent } from '../../admin-listings/listing-overview/listing-document-add-edit/listing-document-add-edit.component';
import { ActionOption, ColumnConfig, DataTableComponent } from '../../../../../app/shared/components/data-table/data-table.component';
import { NotificationService } from '../../../../../app/shared/services/notification-service/notification.service';
import { DateFormatHelperPipe } from '../../../../../app/pipes/date-format-helper.pipe';

@Component({
  selector: 'app-forms-and-documents',
  templateUrl: './forms-and-documents.component.html',
  styleUrls: ['./forms-and-documents.component.scss', '../../../../../css/2-modules/_admin-portal.scss']
})

export class FormsAndDocumentsComponent implements OnInit {

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(DataTableComponent) dataTable: DataTableComponent;

  dataCompletedString: string[] = ['number', 'completedforms', 'date', 'download'];
  dataDocumentsString: string[] = ['number', 'name', 'uploadDate', 'download'];

  dataCompleted = [
    { number: '', completedforms: '', date: '', download: '', actions: '' },
  ];

  columnsCompleted: ColumnConfig[] = [
    { columnDef: 'number', header: 'ID', headerAlign: 'left', cellAlign: 'left', width: 20 },
    { columnDef: 'completedforms', header: 'Completed Forms', headerAlign: 'left', cellAlign: 'left', width: 20 },
    { columnDef: 'date', header: 'Completed Date', headerAlign: 'left', cellAlign: 'left', width: 20 },
    { columnDef: 'download', header: 'Download', headerAlign: 'left', cellAlign: 'left', width: 20 },
    { columnDef: 'actions', header: 'Actions', isAction: true, headerAlign: 'center', cellAlign: 'center', width: 20 }
  ];

  actionOptions: ActionOption[] = [
  ];

  dataDocuments = [
    { number: '', name: '', uploadBy: '', uploadDate: '', download: '', actions: '' },
  ];

  columnsDocuments: ColumnConfig[] = [
    { columnDef: 'number', header: 'ID', headerAlign: 'left', cellAlign: 'left', width: 20 },
    { columnDef: 'name', header: 'Document Name', headerAlign: 'left', cellAlign: 'left', width: 20 },
    { columnDef: 'uploadBy', header: 'Uploaded By', headerAlign: 'left', cellAlign: 'left', width: 20 },
    { columnDef: 'uploadDate', header: 'Uploaded Date', headerAlign: 'left', cellAlign: 'left', width: 20 },
    { columnDef: 'download', header: 'Download', headerAlign: 'left', cellAlign: 'left', width: 10 },
    { columnDef: 'actions', header: 'Actions', isAction: true, headerAlign: 'center', cellAlign: 'center', width: 10 }
  ];

  loading: boolean = false;
  currentUser: UserDto | undefined;
  urbanPlannerDtoList: UrbanPlannerDto[] = [];
  urbanPlannerregisterReport: ReportDocumentDto[] = [];
  estateAgentDtoList: EstateAgentDto[] = [];
  estateAgentDocumentDto: EstateAgentDocumentDto[] | null | undefined = [];
  dataSourceUrbanPlannerRegisterReport = new MatTableDataSource(this.urbanPlannerregisterReport);
  urbanPlannerDocumentDto: UrbanPlannerDocumentDto[] | null | undefined = [];
  dataSourceUrbanPlannerDocuments = new MatTableDataSource(this.urbanPlannerDocumentDto ?? []);
  passedInUserId: string | undefined;
  estateAgentRegisterReport: ReportDocumentDto[] = [];
  dataSourceEstateAgentRegisterReport = new MatTableDataSource(this.estateAgentRegisterReport);

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private notificationService: NotificationService,
    private dateFormatHelperPipe: DateFormatHelperPipe,
    private lookupservice: LookupService,
    private reportService: ReportGeneratorService,
    private planningReportService: PlanningReportService,
    private userManagementService: UserManagementService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.passedInUserId = params["UserProfile"];
    });
    if (this.passedInUserId) {
      this.setCurrentUser(this.passedInUserId);
    }
    else {
      this.getCurrentUser();
    }
  }

  public addDocumentsDialog(): void {
    const AddNewUploadDialog = this.dialog.open(ListingDocumentAddEditComponent, {
      data: {
        fields: null,
        width: '30vw',
        height: '90vh'
      }
    });

    AddNewUploadDialog.afterClosed().subscribe(result => {
      this.refreshDocuments();
    });
  }

  formatDate(date: string): string | null {
    return this.dateFormatHelperPipe.transform(date);
  }

  public generateUrbanPlannerRegisterReport(): void {
    if (!this.currentUser?.id) {
      this.notificationService.showWarningMessage("Warning", "The report can not be generated because of missing Id's.");
      return;
    }

    if (this.urbanPlannerregisterReport.length > 1) {
      this.notificationService.showWarningMessage("Warning", "There is already Urban planner register report.");
      return;
    }

    this.loading = true;
    this.reportService.apiV1ReportGeneratorGenerateUrbanPlannerRegisterReportGet({ userId: this.currentUser?.id })
      .pipe(
        catchError((err) =>
          of(this.notificationService.showErrorMessage("Error", "Could not get the Urban planner Register report."))
        ),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((result: any | void) => {
        this.urbanPlannerregisterReport = result;
        this.dataSourceUrbanPlannerRegisterReport.data = this.urbanPlannerregisterReport ?? [];
      });
  }

  private getCurrentUser(): void {
    this.loading = true;
    const UserData = this.userManagementService.apiV1UserManagementGetCurrentUserLoggedInUserGet()
      .pipe(
        catchError((err) =>
          of(this.notificationService.showWarningMessage("No Current User", "No current user found."))
        ),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((result: UserDto | void) => {
        if (result && result.userRoles) {
          this.currentUser = result ?? undefined;
          if (this.currentUser.userRoles?.some(ur => ur.roleName == "Network Agent" || ur.roleName == "Network Planner" || ur.roleName == "Senior Agent" || ur.roleName == "Principal Agent")) {
            this.refreshDocuments();
          } else {
            this.notificationService.showWarningMessage("Warning", "This user is not agent or Urban planner and no documents will be generated.");
          }
        }
      });
  }

  private refreshDocuments(): void {
    if (this.currentUser?.userRoles?.some(ur => ur.roleName == "Network Agent" || ur.roleName == "Principal Agent" || ur.roleName == "Senior Agent" || ur.roleName == "Principal Agent")) {
      this.getAgentDetails();
      this.getEstateAgentRegisterReport();
    } else if (this.currentUser?.userRoles?.some(ur => ur.roleName == "Network Planner")) {
      this.getUrbanPlannerDetails();
      this.getUrbanPlannerRegisterReport();
    } else {
      this.notificationService.showInfoMessage("Info", "This will only display for urban planners or Agents.");
    }
  }

  async getUrbanPlannerDetails(): Promise<void> {
    this.loading = true;
    const plannerData = this.lookupservice.apiV1LookupGetUrbanPlannerWithUserIdGet({ UrbanPlannerUserId: this.currentUser?.id })
      .pipe(
        catchError((err) =>
          of(this.notificationService.showErrorMessage("Error", "Could not get the Network Planner data."))
        ),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((result: UrbanPlannerDto[] | void) => {
        if (result && result.length > 0) {
          this.urbanPlannerDtoList = [];
          this.urbanPlannerDtoList = result;
          this.urbanPlannerDtoList.forEach(urbanPlannerDto => {
            this.urbanPlannerDocumentDto = urbanPlannerDto.documents;
            this.dataSourceUrbanPlannerDocuments.data = this.urbanPlannerDocumentDto ?? [];
          });
        } else {
          this.notificationService.showErrorMessage("Error", "Could not get the Network Planner data");
        }
      });
  }

  public getUrbanPlannerRegisterReport(): void {
    if (this.currentUser?.id === null || this.currentUser?.id === undefined) {
      this.notificationService.showInfoMessage("Notice", "Could not retrieve the Network Planner registration report. Please try again later of contact Property Matrix Administrator.");
    } else {
      this.loading = true;
      this.planningReportService.apiV1PlanningReportGetReportDocumentsGet({ planningReportId: this.currentUser.id })
        .pipe(
          catchError((err) =>
            of(this.notificationService.showErrorMessage("Error", "Could not get the Planning reports Ownership."))
          ),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe((result: ReportDocumentDto[] | void) => {
          if (result && result.length > 0) {
            this.urbanPlannerregisterReport = result;
            this.dataSourceUrbanPlannerRegisterReport.data = this.urbanPlannerregisterReport ?? [];
          } else {
            this.generateUrbanPlannerRegisterReport();
          }
        });
    }
  }

  private setCurrentUser(userId: string): void {
    this.loading = true;
    this.userManagementService.apiV1UserManagementGetCurrentUserByIdGet({ id: userId })
      .pipe(
        catchError((err) =>
          of(this.notificationService.showWarningMessage('No Current User', 'No current user found.'))
        ),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((result: UserDto | void) => {
        if (result && result.userRoles) {
          this.currentUser = result ?? undefined;
          if (this.currentUser.userRoles?.some(ur => ur.roleName == "Network Agent" || ur.roleName == "Principal Agent" || ur.roleName == "Senior Agent" || ur.roleName == "Principal Agent" || ur.roleName == "Network Planner")) {
            this.refreshDocuments();
          } else {
            this.notificationService.showWarningMessage("Warning", "This agent has no documents.");
          }
        }
      });
  }

  async getAgentDetails(): Promise<void> {
    this.loading = true;
    const plannerData = this.lookupservice.apiV1LookupGetEstateUsersWithUserIdGet({ EstateAgentUserId: this.currentUser?.id })
      .pipe(
        catchError((err) =>
          of(this.notificationService.showErrorMessage("Error", "Could not get the Network Planner data."))
        ),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((result: EstateAgentDto[] | void) => {
        if (result && result.length > 0) {
          this.estateAgentDtoList = result;
          this.estateAgentDtoList.forEach(estateAgentDto => {
            this.estateAgentDocumentDto = estateAgentDto.documents ?? undefined;
            this.dataSourceUrbanPlannerDocuments.data = this.estateAgentDocumentDto ?? [];
          });

        } else {
          this.notificationService.showErrorMessage("Error", "Could not get the Network Planner data");
        }
      });
  }

  public getEstateAgentRegisterReport(): void {
    if (this.currentUser?.id === null || this.currentUser?.id === undefined) {
      this.notificationService.showInfoMessage("Notice", "The report can not be generated because of missing user Id.");
    } else {
      this.loading = true;
      this.planningReportService.apiV1PlanningReportGetReportDocumentsGet({ planningReportId: this.currentUser.id })
        .pipe(
          catchError((err) =>
            of(this.notificationService.showErrorMessage("Error", "Could not get the Estate Agent registration report."))
          ),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe(async (result: ReportDocumentDto[] | void) => {
          if (result && result.length > 0) {
            this.estateAgentRegisterReport = result;
            this.dataSourceEstateAgentRegisterReport.data = this.estateAgentRegisterReport;
          } else {
            await this.generateEstateAgentRegisterReport();
          }
        });
    }
  }

  public generateEstateAgentRegisterReport(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (this.currentUser?.id == null) {
        this.notificationService.showInfoMessage("Notice", "Could not retrieve the estate agent registration report. Please try again later or contact the Property Matrix Administrator.");
        reject("User ID is null or undefined");
        return;
      }

      this.loading = true;

      this.reportService.apiV1ReportGeneratorGenerateAgentRegisterReportGet({ userId: this.currentUser.id })
        .pipe(
          catchError((err) => {
            this.notificationService.showErrorMessage("Error", "Could not get the Planning reports.");
            reject(err);
            return of(this.notificationService.showErrorMessage("Error", "Could not get the Estate Agent registration report ."));
          }),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe((result: any | void) => {
          if (result) {
            this.estateAgentRegisterReport = result;
            this.dataSourceEstateAgentRegisterReport.data = result;
            resolve(true);
          }
        });
    });
  }
}
